import { GAP_BETWEEN_SIDE_BANNERS } from './enums'

const FIRST_SIDE_BANNER_CONTAINER_HEIGHT = 1200

const MIN_HEIGHT_TO_SHOW_SECOND_BANNER = 600 // banner height

export function getFirstWidgetPageBannerContainerHeight({ content }) {
  if (!content) return

  const { height: contentHeight } = content

  return Math.min(Math.floor(contentHeight), FIRST_SIDE_BANNER_CONTAINER_HEIGHT)
}

export function getSecondWidgetPageBannerContainerHeight({ content }) {
  if (!content) return

  const { height: contentHeight } = content

  const resultHeight =
    contentHeight -
    FIRST_SIDE_BANNER_CONTAINER_HEIGHT -
    GAP_BETWEEN_SIDE_BANNERS

  return resultHeight >= MIN_HEIGHT_TO_SHOW_SECOND_BANNER
    ? Math.floor(resultHeight)
    : null
}
